<template>
  <div :class="isOnMobile ? 'box-container' : 'box-container-horizontal'" class="ma-0 pa-0" style="height: 100%" align-content="start" justify="center">
    <v-dialog v-model="showConfiguration" value="isExportWindowVisible" :max-width="600" style="overflow: hidden">
      <v-card class="ma-0 pa-2" align-items="center" :height="600" :max-width="600">
        <div class="box-container ma-0 pa-0" style="max-width: 600px">
          <div class="row-header ma-0 pa-0">
            <v-row class="ma-2 pa-0" align="center">
              <v-card-title :class="IF.MyFontTitle">{{ s ? "Параметри" : "" }}</v-card-title>
              <t-btn v-if="s && config" size="small" style="justify-content: center; border-radius: 20px" @click="editMode = !editMode">
                <template v-if="editMode">
                  <v-icon size="24">mdi-check</v-icon>
                </template>
                <template v-else>
                  <v-icon size="24">mdi-pencil</v-icon>
                </template>
              </t-btn>
              <v-spacer></v-spacer>
              <t-btn size="small" @click="showConfiguration = false" style="justify-content: center; border-radius: 20px">
                <v-icon size="24">mdi-close</v-icon>
              </t-btn>
            </v-row>
          </div>
          <div v-if="config" class="ma-0 pa-0 row-content" style="flex-basis: 0 !important">
            <v-row
              class="ma-0 pa-0"
              v-for="(value, key, index) in config"
              :key="index"
              :style="
                (isImportant(key) ? 'background: ' + Colors.ActiveItemBackground : '') +
                (editMode && !key.endsWith('(readonly)') ? 'cursor: pointer; text-decoration: underline' : '')
              "
              @click="editMode && !key.endsWith('(readonly)') ? changeCfg(key, value) : ''"
            >
              <span class="ma-0 pa-0" :style="`font-size: ${12 + IF.Font}px; white-space: pre;`">{{ key + ": " }} </span>
              <span class="ma-0 pa-0" :style="`max-width: 560px !important; text-align: end; word-wrap: break-word; font-size: ${12 + IF.Font}px;`"
                >{{ value }}
              </span>
            </v-row>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <loading-component v-if="!datatype || datatype.isLoading" style="width: 100%"> </loading-component>
    <error-component
      v-else-if="datatype && datatype.errorMessage"
      style="width: 100%"
      :text="datatype.errorMessage"
      align="center"
      justify="center"
      class="row-header ma-0 pa-0"
    >
    </error-component>
    <template v-else>
      <station-list
        class="row-header ma-0 pa-2"
        v-model="s"
        :showAll="false"
        :showFilters="true"
        :items="stations"
        :width="isOnMobile ? '100%' : 300"
        :height="isOnMobile && s ? 250 : '100%'"
        :slotHeight="0"
      >
      </station-list>
      <div class="row-content ma-0 pa-0" :align="isOnMobile ? 'center' : ''">
        <charge-station-card
          v-if="s"
          :station="s"
          class="ma-2 text-center"
          :elevation="3"
          :width="360"
          :max-width="360"
          :height="580"
          :connector="conn"
          :connectorClick="(cnn) => selectConnector(cnn)"
          :editClick="() => edit()"
          :showPrice="true"
          :imageClick="toshoDebug"
        >
          <template v-slot:subtitle>
            <span>{{ "ID: " + s.id }} </span>
            <span>{{ "УБ: " + (s.fd ? s.fd.sn : "") }} </span>
          </template>
          <template v-slot:bottom>
            <t-btn
              class="ma-1"
              @click="changePrice()"
              :disabled="!conn || conn.statusNotifReqStr == ChargeStationConnectorStatus.Charging"
              style="justify-content: start"
            >
              <v-icon :size="25" class="mr-2">mdi-cash-check</v-icon>
              <span> Смяна на цена </span>
            </t-btn>
            <t-btn class="ma-1" @click="setFreeMode()" :disabled="!conn" style="justify-content: start">
              <v-icon :size="25" class="mr-2">{{ conn && conn.free ? "mdi-cash-check" : "mdi-cash-remove" }}</v-icon>
              <span>{{ conn && conn.free ? "Изключване на безплатен режим" : "Включване на безплатен режим" }}</span>
            </t-btn>
            <t-btn
              class="ma-1"
              @click="startCharge()"
              :disabled="
                !conn || (conn.statusNotifReqStr != ChargeStationConnectorStatus.Preparing && conn.statusNotifReqStr != ChargeStationConnectorStatus.Finishing)
              "
              style="justify-content: start"
            >
              <v-icon :size="25" class="mr-2">mdi-battery-charging</v-icon>
              <span> Отдалечено стартиране на заряд </span>
            </t-btn>
            <t-btn
              class="ma-1"
              @click="stopCharge()"
              :disabled="!conn || conn.statusNotifReqStr != ChargeStationConnectorStatus.Charging"
              style="justify-content: start"
            >
              <v-icon :size="25" class="mr-2">mdi-battery-off</v-icon>
              <span> Отдалечено спиране на заряд </span>
            </t-btn>
            <t-btn
              class="ma-1"
              @click="unlock()"
              :disabled="
                !conn || (conn.statusNotifReqStr != ChargeStationConnectorStatus.Preparing && conn.statusNotifReqStr != ChargeStationConnectorStatus.Finishing)
              "
              style="justify-content: start"
            >
              <v-icon :size="25" class="mr-2">mdi-lock-open</v-icon>
              <span>Отключване на конектора</span>
            </t-btn>
            <t-btn class="ma-1" @click="restart()" :disabled="s.Status != ChargeStationStatus.Online" style="justify-content: start">
              <v-icon :size="25" class="mr-2">mdi-restart</v-icon>
              <span>Рестартиране на станцията</span>
            </t-btn>
            <t-btn class="ma-1" @click="loadConfiguration()" :disabled="s.Status != ChargeStationStatus.Online" style="justify-content: start">
              <v-icon :size="25" class="mr-2">mdi-cog-transfer-outline</v-icon>
              <span>Конфигурация</span>
            </t-btn>
          </template>
        </charge-station-card>
      </div>
    </template>
  </div>
  <v-dialog v-model="showDebug" style="width: 500px; height: 90vh" persistent>
    <v-row class="row-content" style="width: 500px; max-height: 90vh; overflow: auto" fill-height align="center" justify="center">
      <JsonViewer v-if="showDebug" :value="json" :expanded="true" :expand-depth="5" class="customize" />
      <v-btn size="small" style="position: fixed; top: -5px; right: -5px" @click="showDebug = false" icon="mdi-close"></v-btn>
      <v-btn size="small" style="position: fixed; top: -5px; right: 45px" @click="loadData" icon="mdi-refresh"></v-btn>
    </v-row>
  </v-dialog>
</template>

<script>
import HTTPSender from "@/js/HTTPSender";
import DataManager from "@/data/DataManager";
import ChargeStationConnectorStatus from "@/js/ChargeStationConnectorStatus";
import ChargeStationStatus from "@/js/ChargeStationStatus";
import { g_Dialog } from "@/main";
import { DataHeader } from "@/data/DataHeader";
import { DataPropType } from "@/data/DataFilter";

export default {
  components: {},
  props: {
    currentStation: null,
  },
  data: () => ({
    debug: 0,
    showDebug: false,
    s: null,
    conn: null,
    datatype: null,
    stations: [],
    editMode: false,
    config: null,
    showConfiguration: false,
    ChargeStationConnectorStatus: ChargeStationConnectorStatus,
    ChargeStationStatus: ChargeStationStatus,
  }),
  computed: {
    json() {
      var o = Object.assign({}, this.s);
      delete o.Image;
      delete o.toString;
      return o;
    },
  },
  methods: {
    setMeta(meta, err) {
      this.datatype = meta.datatype;
      if (err.success && !err.message) {
        this.stations = this.datatype.data ?? [];
        this.datatype.isLoading = false;
        if (this.$route.query.id) {
          this.s = this.stations.find((s) => s.id == this.$route.query.id);
          // this.selectStation(this.stations.find((s) => s.id == this.$route.query.id));
        }
      } else {
        this.datatype.errorMessage = err.message;
        this.datatype.isLoading = false;
      }
    },
    async loadData() {
      await DataManager.loadData(DataManager.data.ChargeStation);
      this.stations = [];
      this.$nextTick(() => {
        var id = this.s.id;
        this.s = null;
        this.stations = DataManager.getData(DataManager.data.ChargeStation, true);
        this.$nextTick(() => {
          this.s = this.stations.find((ss) => ss.id == id);
        });
      });
    },
    selectStation() {},
    // selectStation(station) {
    //   this.s = null;
    //   this.$nextTick(() => {
    //     this.s = station;
    //   });
    // },
    selectConnector(value) {
      if (this.conn && this.conn == value) {
        this.conn = null;
      } else {
        this.conn = value;
      }
    },
    changePrice() {
      if (!this.conn) {
        return;
      }
      g_Dialog.show(
        g_Dialog.dialog_types.input_dialog,
        this.conn.price_per_kwh.toFixed(2),
        {
          title: "Нова цена за конектор " + this.conn.cpCtrId,
          placeholder: "Цена",
          buttonYesText: "OK",
          buttonCancelText: "Отказ",
        },
        (res) => {
          if (res && Number(res) != this.conn.price1Kwh) {
            g_Dialog
              .show(g_Dialog.dialog_types.loader, null, {
                message: "Промяна на цена на конектор " + this.conn.cpCtrId + ", моля изчакайте...",
              })
              .then(() => {
                HTTPSender.SendGETreq("Command/ChangeCSCtrPrice/" + this.s.id + "/" + this.conn.cpCtrId + "?price=" + Number(res).toFixed(2))
                  .done((res) => {
                    g_Dialog.close();
                    if (res.success) {
                      g_Dialog.showInfo("Успешна промяна на цена.");
                    } else {
                      g_Dialog.showError("Грешка при промяна на цена!\n" + (res.err ? res.err.message : ""));
                    }
                    setTimeout(() => {
                      this.loadData();
                    }, 2222);
                  })
                  .fail((err) => {
                    g_Dialog.close();
                    console.log("fail");
                    console.log(JSON.stringify(err));
                  });
              });
          }
        }
      );
    },
    edit() {
      var o = Object.assign({}, { name: this.s.name, Address: this.s.settings1.Address, location: this.s.location });
      g_Dialog.show(
        g_Dialog.dialog_types.editor,
        o,
        {
          title: "Редакция на зарядната станция",
          headers: [
            new DataHeader("Име", "name", DataPropType.String, { isNullable: false }),
            new DataHeader("Адрес", "Address", DataPropType.String, { isNullable: true }),
            new DataHeader("Latitude", "location.lat", DataPropType.Number, { isNullable: true }),
            new DataHeader("Longitude", "location.lng", DataPropType.Number, { isNullable: true }),
          ],
        },

        // g_Dialog.dialog_types.input_dialog,
        // this.s.name,
        // {
        //   title: "Ново име:",
        //   placeholder: "Име",
        //   buttonYesText: "OK",
        //   buttonCancelText: "Отказ",
        // },
        (edit_item) => {
          if (edit_item) {
            g_Dialog
              .show(g_Dialog.dialog_types.loader, null, {
                message: "Редакция на информацията за станцията, моля изчакайте...",
              })
              .then(() => {
                HTTPSender.SendPOSTreq(
                  JSON.stringify({
                    chargePointId: this.s.id,
                    name: edit_item.name,
                    settings1: JSON.stringify({ ...this.s.settings1, Address: edit_item.Address }),
                    location: JSON.stringify(edit_item.location),
                  }),
                  "Command/UpdateCP"
                )
                  .done((res) => {
                    g_Dialog.close();
                    if (res.success) {
                      g_Dialog.showInfo("Успешна операция.");
                    } else {
                      g_Dialog.showError("Грешка при редакция на информацията за станцията!\n" + res.status);
                    }
                    setTimeout(() => {
                      this.loadData();
                    }, 2222);
                  })
                  .fail((err) => {
                    g_Dialog.close();
                    console.log("fail");
                    console.log(JSON.stringify(err));
                  });
              });
          }
        }
      );
    },
    restart() {
      g_Dialog.show(
        g_Dialog.dialog_types.yes_no,
        null,
        {
          title: "Внимание",
          text: "Сигурни ли сте, че искате да рестартирате станцията?",
          buttonYesText: "Да",
          buttonNoText: "Не",
        },
        (confirm) => {
          if (confirm) {
            g_Dialog
              .show(g_Dialog.dialog_types.loader, null, {
                message: "Изпращане на заявка за рестартиране на станцията, моля изчакайте...",
              })
              .then(() => {
                HTTPSender.SendGETreq_API_OLD("Reset/" + this.s.id + "/1")
                  .done(() => {
                    g_Dialog.close().then(() => {
                      g_Dialog.showInfo("Станцията е рестартирана.");
                      setTimeout(() => {
                        this.loadData();
                      }, 2222);
                    });
                  })
                  .fail((err) => {
                    g_Dialog.showError("Грешка. " + JSON.stringify(err));
                    console.log("fail");
                    console.log(JSON.stringify(err));
                  });
              });
          }
        },
        null
      );
    },
    startCharge() {
      if (!this.conn) {
        return;
      }
      g_Dialog
        .show(g_Dialog.dialog_types.loader, null, {
          message: "Изпращане на заявка за отдалечено стартиране на заряд на конектор " + this.conn.cpCtrId + ", моля изчакайте...",
        })
        .then(() => {
          HTTPSender.SendGETreq_API_OLD("RemoteStartTransaction/" + this.s.id + "/" + this.conn.cpCtrId)
            .done((res) => {
              g_Dialog.close();
              if (res.status == "Accepted") {
                g_Dialog.showInfo("Заряда е стартиран.");
              } else {
                g_Dialog.showError("Грешка при стартиране на заряд!\n" + res.status);
              }
              setTimeout(() => {
                this.loadData();
              }, 2222);
            })
            .fail((err) => {
              g_Dialog.close();
              console.log("fail");
              console.log(JSON.stringify(err));
            });
        });
    },
    stopCharge() {
      if (!this.conn) {
        return;
      }
      g_Dialog
        .show(g_Dialog.dialog_types.loader, null, {
          message: "Изпращане на заявка за отдалечено спиране на заряд на конектор " + this.conn.cpCtrId + ", моля изчакайте...",
        })
        .then(() => {
          HTTPSender.SendGETreq_API_OLD("RemoteStopTransaction/" + this.s.id + "/" + this.conn.cpCtrId)
            .done((res) => {
              g_Dialog.close();
              if (res.status == "Accepted") {
                g_Dialog.showInfo("Заряда е спрян.");
              } else {
                g_Dialog.showError("Грешка при спиране на заряд!\n" + res.status);
              }
              setTimeout(() => {
                this.loadData();
              }, 2222);
            })
            .fail((err) => {
              g_Dialog.close();
              console.log("fail");
              console.log(JSON.stringify(err));
            });
        });
    },
    unlock() {
      if (!this.conn) {
        return;
      }
      g_Dialog
        .show(g_Dialog.dialog_types.loader, null, {
          message: "Изпращане на заявка за отключване на конектор " + this.conn.cpCtrId + ", моля изчакайте...",
        })
        .then(() => {
          HTTPSender.SendGETreq_API_OLD("UnlockConnector/" + this.s.id + "/" + this.conn.cpCtrId)
            .done((res) => {
              g_Dialog.close();
              if (res.status == "Accepted") {
                g_Dialog.showInfo("Конектора е отключен.");
              } else {
                g_Dialog.showError("Грешка при отключване!\n" + res.status);
              }
              setTimeout(() => {
                this.loadData();
              }, 2222);
            })
            .fail((err) => {
              g_Dialog.close();
              console.log("fail");
              console.log(JSON.stringify(err));
            });
        });
    },
    setFreeMode() {
      if (!this.conn) {
        return;
      }
      var isOn = this.conn.free;
      var msg = isOn ? "Изключване на безплатен режим" : "Включване на безплатен режим";
      msg += " за конектор " + this.conn.cpCtrId;
      g_Dialog.show(
        g_Dialog.dialog_types.yes_no,
        null,
        {
          title: "Внимание",
          text: msg + "?",
          buttonYesText: "Да",
          buttonNoText: "Не",
        },
        (confirm) => {
          if (confirm) {
            g_Dialog
              .show(g_Dialog.dialog_types.loader, null, {
                message: msg + ", моля изчакайте... ",
              })
              .then(() => {
                HTTPSender.SendGETreq("Command/SetFreeCharge/" + this.s.id + "/" + this.conn.cpCtrId + "/" + !this.conn.free) //TODO + "?key=QWERTY"
                  .done((res) => {
                    g_Dialog.close().then(() => {
                      if (res.success) {
                        g_Dialog.showInfo(isOn ? "Изключен безплатен режим." : "Включен безплатен режим.");
                      } else {
                        g_Dialog.showError("Грешка при включване/изключване на безплатен режим!\n" + (res.err ? res.err.message : ""));
                      }
                      setTimeout(() => {
                        this.loadData();
                      }, 2222);
                    });
                  })
                  .fail((err) => {
                    g_Dialog.close().then(() => {
                      g_Dialog.showError("Грешка. " + JSON.stringify(err));
                      console.log("fail");
                      console.log(JSON.stringify(err));
                    });
                  });
              });
          }
        },
        null
      );
    },
    calcOfflineMinutes(dateForDiff) {
      var diffMs = new Date() - dateForDiff;
      var mins = Math.round(diffMs / 60000);
      var m = mins % 60;
      var h = (mins - m) / 60;
      if (h > 0) {
        return h + " ч. " + m + " мин.";
      }
      return m + " мин.";
    },

    loadConfiguration() {
      this.config = null;
      this.$nextTick(() => {
        if (this.s) {
          g_Dialog
            .show(g_Dialog.dialog_types.loader, null, {
              message: "Зареждане на конфигурация за станция " + this.s.name + ", моля изчакайте...",
            })
            .then(() => {
              HTTPSender.SendGETreq_API_OLD("GetConfiguration/" + this.s.id)
                .done((resp) => {
                  g_Dialog.close().then(() => {
                    var cfg = {};
                    var valz = Object.values(resp.configurationKey);
                    valz.sort((a, b) => a.key.localeCompare(b.key));
                    valz.forEach((o) => {
                      cfg[o.key + (o.readonly ? " (readonly)" : "")] = o.value;
                    });
                    this.config = cfg;
                    this.$nextTick(() => {
                      this.showConfiguration = true;
                    });
                  });
                })
                .fail((err) => {
                  g_Dialog.close().then(() => {
                    g_Dialog.showError("Грешка. " + JSON.stringify(err));
                    console.log("fail");
                    console.log(JSON.stringify(err));
                  });
                });
            });
        }
      });
    },

    isImportant(key) {
      var arr = ["LocalPreAuthorize", "AuthorizeRemoteTxRequests", "MeterValueSampleInterval"];
      for (var i = 0; i < arr.length; i++) {
        if (key.contains(arr[i])) {
          return true;
        }
      }
      return false;
    },
    changeCfg(key, val) {
      g_Dialog.show(
        g_Dialog.dialog_types.input_dialog,
        val,
        {
          title: "Промяна на параметър " + key,
          placeholder: val,
          buttonYesText: "OK",
          buttonCancelText: "Отказ",
        },
        (editRes) => {
          if (editRes) {
            g_Dialog
              .show(g_Dialog.dialog_types.loader, null, {
                message: "Промяна на параметър " + key + " на зарядна станция " + this.s.name + ", моля изчакайте...",
              })
              .then(() => {
                HTTPSender.SendGETreq_API_OLD("RemoteChangeConfiguration/" + this.s.id, { key: key, value: editRes })
                  .done((res) => {
                    g_Dialog.close().then(() => {
                      if (res.status == "Accepted") {
                        this.config[key] = editRes;
                        g_Dialog.showInfo("Успешна операция.");
                      } else {
                        g_Dialog.showError("Грешка при промяна на параметър! " + res.status);
                      }
                    });
                  })
                  .fail((err) => {
                    g_Dialog.close().then(() => {
                      g_Dialog.showError("Грешка. " + JSON.stringify(err));
                      console.log("fail");
                      console.log(JSON.stringify(err));
                    });
                  });
              });
          }
        }
      );
    },

    toshoDebug() {
      this.debug++;
      if (this.debug == 5) {
        this.debug = 0;
        this.showDebug = true;
      }
    },
  },

  watch: {
    // s: {
    //   handler() {
    //   },
    // },
  },
  // mounted() {},
  // created() {
  //   window.addEventListener("resize", this.recalcContainerHeight);
  // },
  // beforeUnmount() {
  //   window.removeEventListener("resize", this.recalcContainerHeight);
  // },
  // setup() {
  //   const refContainer = ref(null);
  //   return { refContainer };
  // },
};
</script>

<style lang="scss" scoped>
.animated {
  height: 100px;
  color: green;
  -webkit-animation-name: greenBlink;
  -o-animation-name: greenBlink;
  -moz-animation-name: greenBlink;
  animation-name: greenBlink;

  -webkit-animation-iteration-count: infinite;
  -o-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  animation-iteration-count: infinite;

  -webkit-animation-duration: 2s;
  -o-animation-duration: 2s;
  -moz-animation-duration: 2s;
  animation-duration: 2s;
}

@-webkit-keyframes greenBlink {
  0% {
    color: green;
  }
  50% {
    color: rgb(19, 185, 19);
  }
  51% {
    color: green;
  }
  100% {
    color: rgb(19, 185, 19);
  }
}

@-moz-keyframes greenBlink {
  0% {
    color: green;
  }
  50% {
    color: rgb(19, 185, 19);
  }
  51% {
    color: green;
  }
  100% {
    color: rgb(19, 185, 19);
  }
}
@-moz-keyframes greenBlink {
  0% {
    color: green;
  }
  50% {
    color: rgb(19, 185, 19);
  }
  51% {
    color: green;
  }
  100% {
    color: rgb(19, 185, 19);
  }
}

@keyframes greenBlink {
  0% {
    color: green;
  }
  50% {
    color: rgb(19, 185, 19);
  }
  51% {
    color: green;
  }
  100% {
    color: rgb(19, 185, 19);
  }
}
</style>

<style scoped>
.customize {
  font-size: 15px;
  --vjc-key-color: #0977e6;
  --vjc-valueKey-color: #073642;
  --vjc-string-color: #268bd2;
  --vjc-number-color: #2aa198;
  --vjc-boolean-color: #cb4b16;
  --vjc-null-color: #6c71c4;
  --vjc-arrow-size: 2px;
  --vjc-arrow-color: #444;
  --vjc-hover-color: rgba(0, 0, 0, 0.15);
}
.vm--overlay {
  background: rgba(0, 0, 0, 0.8);
}
.modal-style {
  padding: 10px;
  font-style: 12px;
  border-radius: 1px;
  border: 1px solid gray;
  box-shadow: 5px 5px 30px 0px rgba(46, 61, 73, 0.6);
}
.modal-border {
  border: 1px solid gray;
}
</style>
